let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b4dsH")).then(() => parcelRequire('a8hd9'));